
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { changedFields, initialActions, openDesktopRecordAtom, saveAvailable } from "../../../../recoil-store/recoil-state";
import { CheckIfFlowUpdated } from "../../../../helpers/helper";
import FieldLabel from "../../../FlowConfigurationInputs/FieldLabel/FieldLabel";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import IncrementByOne from "../../../FlowConfigurationInputs/IncrementByOne/IncrementByOne";
import { Button } from '@material-ui/core';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function SmoothScroll({ action, variables, setOpenVariable, variableRender, fromFlow, handleSave }) {
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const [smoothValue, setSmoothValue] = useState(action.fields?.incrementStateSmooth?.value);
    const setOpenDesktopRecord = useSetRecoilState(openDesktopRecordAtom)
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.DESKTOP-ACTIONS.SMOOTH-SCROLL.";

    useEffect(() => {
        if (!action.fields.incrementStateSmooth) {
            action.fields.incrementStateSmooth = { value: 1 };
            setSmoothValue(1);
        }
        if (!action.fields.imgURL) {
            action.fields.imgURL = { value: "" };
        }
        if (!action.fields.completedCrop) {
            action.fields.completedCrop = { value: [] };
        }
        if (!action.fields.source) {
            action.fields.source = { value: { width: 0, height: 0, x: 0, y: 0, id: "asdf" } };
        }
        if (!action.fields.resolution) {
            action.fields.resolution = { value: { width: 0, height: 0 } };
        }
        if (!action.fields.difference) {
            action.fields.difference = { value: "" };
        }
        if (!action.fields.highlightedElements) {
            action.fields.highlightedElements = { value: { clickedObj: [], neighbourObj: [] } }
        }
        if (!action.fields.cropImg) {
            action.fields.cropImg = { value: "" };
        }
    }, [action, variables, variableRender]);

    const handleIncrementByOne = (aField, setState) => {
        if (action.fields[aField].value + 1 < 4) {
            action.fields[aField].value++;
            setState(action.fields[aField].value);
            const field = initialActionsData[action.id]?.fields[aField];
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(aField, action, oldValue, action.fields[aField].value, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    };

    const handleDecrementByOne = (aField, setState, state) => {
        if (action.fields[aField].value - 1 > 0) {
            action.fields[aField].value--;
            state - 1 > 0 ? setState(state - 1) : setState(state);
            const field = initialActionsData[action.id]?.fields[aField];
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(aField, action, oldValue, action.fields[aField].value, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    };

    return (
        <>
            <div className='conf-field-container'>
                {fromFlow && <div>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenDesktopRecord(true)}
                        style={{
                            background: "#031226",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                            borderRadius: 4,
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: '11px'
                        }}
                    >
                        {t(label + "INITIATE-SELECTOR")}
                    </Button>
                </div>}
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'SCROLL-DURATION')} />
                <TextInput action={action} inputName="duration" variables={variables}
                    setOpenVariable={setOpenVariable} filter="string" />
                <small className="small-helper">{t(label + "SCROLL-DURATION-HELPER")}</small>
            </div>
            <IncrementByOne
                action={action}
                handleIncrement={() => handleIncrementByOne("incrementStateSmooth", setSmoothValue)}
                handleDecrement={() => handleDecrementByOne("incrementStateSmooth", setSmoothValue, smoothValue)}
                field={"incrementStateSmooth"}
                labelText={"SCROLL-SPEED"}
            />
            {handleSave &&
                <Button
                    variant="outlined"
                    className="desktop-actions-button"
                    onClick={() => handleSave()}
                >
                    {t(label + "CREATE-SELECTOR")}
                </Button>}
        </>
    )
}

export default SmoothScroll;